import { createHostModule } from '@wix/sdk-runtime/host-modules';
import { AdminHost, InternalSDK } from './types.js';

export const legacy = createHostModule<AdminHost, InternalSDK>({
  getContextIds: (host) => () => {
    if (!host.admin) {
      throw new Error(
        'admin is not available on the current host. Make sure to use an updated version of the host initialization package.',
      );
    }

    if (!host.admin.getContextIds) {
      throw new Error(
        'getContextIds is not available on the current host. Make sure to use an updated version of the host initialization package.',
      );
    }

    const getContextIds = host.admin.getContextIds();

    if (!getContextIds) {
      throw new Error(
        'getContextIds is not available on the current host. Make sure to use an updated version of the host initialization package.',
      );
    }

    return getContextIds;
  },
});
